module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', {
    directives: [{
      name: "min-height",
      rawName: "v-min-height"
    }]
  }, [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "alpha-register"
  }, [_c('div', {
    staticClass: "header bg-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "register-form"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-telephone prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.account),
      expression: "formData.account",
      modifiers: {
        "trim": true
      }
    }],
    ref: "J_phone",
    staticClass: "prepend-icon",
    attrs: {
      "type": "phone",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.formData.account)
    },
    on: {
      "blur": [_vm.handlerBlurPhone, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.account = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-password prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.password),
      expression: "formData.password",
      modifiers: {
        "trim": true
      }
    }],
    ref: "J_pwd",
    staticClass: "prepend-icon",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "blur": [_vm.resetScroll, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-password prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.verifycode),
      expression: "formData.verifycode",
      modifiers: {
        "trim": true
      }
    }],
    ref: "J_code",
    staticClass: "prepend-icon",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.formData.verifycode)
    },
    on: {
      "blur": [_vm.resetScroll, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.verifycode = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code__box"
  }, [(_vm.formData.flowId) ? _c('img', {
    attrs: {
      "src": _vm.codeImgPath,
      "alt": ""
    },
    on: {
      "click": _vm.initCodePath
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "s-btn s-btn--orange",
    on: {
      "click": function($event) {
        _vm.nextStep()
      }
    }
  }, [_vm._v("免费注册开通")]), _vm._v(" "), _c('p', {
    staticClass: "mt-20 text-center text-color gray"
  }, [_vm._v("\n            点击免费注册开通，即同意\n            "), _c('a', {
    staticClass: "text-color orange",
    on: {
      "click": function($event) {
        _vm.goUserTerm()
      }
    }
  }, [_vm._v("《生意专家用户协议》")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('info-footer')], 1)])])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3967eaee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/newagent-regsiter-user/index.vue
// module id = 360
// module chunks = 0